export const constants = {
  SHOW_COOKIES: 'SHOW_COOKIES',
};
